import styled from '@emotion/styled';
import { SkeletonBar, SkeletonCircle, SkeletonRect, SkeletonBase } from 'src/components/Skeleton';
const Item = styled(SkeletonBase)`
  width: 128px;
  min-height: 161px;
  border-radius: 16px;

  ${({
  theme
}) => theme.screenSize.desktop} {
    width: 100%;
    min-height: 0px;
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-direction: row;
    gap: 16px;

    padding: 12px 24px;
    border-radius: 0;
    background-color: transparent;
    animation: none;
  }
`;
const ProfileInfo = styled.div`
  width: 100%;
  min-width: 0;

  display: none;

  ${({
  theme
}) => theme.screenSize.desktop} {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1;

    flex-direction: row;
    gap: 16px;
  }
`;
const NameGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;

  ${({
  theme
}) => theme.screenSize.desktop} {
    flex: 1;
    align-items: flex-start;
  }
`;
const Avatar = styled(SkeletonCircle)`
  ${({
  theme
}) => theme.screenSize.desktop} {
    width: 56px;
    height: 56px;
  }
`;
const ActionButton = styled(SkeletonRect)`
  height: 32px;
  display: none;

  ${({
  theme
}) => theme.screenSize.desktop} {
    height: 40px;
    display: block;
  }
`;
const SkeletonItem = () => <Item data-sentry-element="Item" data-sentry-component="SkeletonItem" data-sentry-source-file="Skeleton.tsx">
    <ProfileInfo data-sentry-element="ProfileInfo" data-sentry-source-file="Skeleton.tsx">
      <Avatar size={56} data-sentry-element="Avatar" data-sentry-source-file="Skeleton.tsx" />
      <NameGroup data-sentry-element="NameGroup" data-sentry-source-file="Skeleton.tsx">
        <SkeletonBar width='60px' height={17} data-sentry-element="SkeletonBar" data-sentry-source-file="Skeleton.tsx" />
        <SkeletonBar width='40px' height={15} data-sentry-element="SkeletonBar" data-sentry-source-file="Skeleton.tsx" />
      </NameGroup>
    </ProfileInfo>
    <ActionButton width='74px' radius={20} data-sentry-element="ActionButton" data-sentry-source-file="Skeleton.tsx" />
  </Item>;
const FollowListSkeleton = () => Array.from({
  length: 5
}, (_, i) => <SkeletonItem key={i} />);
export default FollowListSkeleton;